export default __webpack_public_path__ + "static/apple-touch-icon-1b58e4980ba8e1da64a6fb1bede7fa30.png";